module.exports = __webpack_public_path__ + "img/shopping.5d20164e.svg";